/**
 * 导航菜单下方车型匹配
 * */

/*如果是购物车|详情页面不展示搜索框**/
if(/^\/cart/.test(location.pathname)||/\/products\//.test(location.pathname)){
    document.querySelector('#ymm_hid').style.display = 'none';
}else{
    document.querySelector('#ymm_hid > .dropdowns').innerHTML = `
        <li class="field_1">
            <select name="vue-select-for-shop-by-vehicle-select-year" @change="changeYear" v-model="currentYear">
                <option v-for="(item,i) in yearList" :key="i" :value="item.value">{{item.label}}</option>
            </select>     
        </li>
        <li class="field_2">
            <select name="vue-select-for-shop-by-vehicle-select-make" @change="changeMake" v-model="currentMake">
                <option v-for="(item,i) in makeList" :key="i" :value="item.value">{{item.label}}</option>
            </select>     
        </li>
        <li class="field_3">
            <select name="vue-select-for-shop-by-vehicle-select-model" @change="changeModel" v-model="currentModel">
                <option v-for="(item,i) in modelList" :key="i" :value="item.value">{{item.label}}</option>
            </select>     
        </li>
        <li class="field_4">
            <select name="vue-select-for-shop-by-vehicle-select-trim" @change="changeTrim" v-model="currentTrim">
                <option v-for="(item,i) in trimList" :key="i" :value="item.value">{{item.label}}</option>
            </select>     
        </li>

        <li class="ymm_bttns">
            <div id="ymm_actions" class="button-action" align="center">
                <input type="button" name="submit" id="ymm_search" value="SEARCH" class="btn ymm_search" :disabled="!isAllowSubmit" @click="handlerSubmit">
                <input type="button" name="reset" id="ymm_reset" value="RESET" class="btn btn--secondary" @click="resetForm">
            </div> 
        </li>
    `;

    const { createApp } = Vue
    const YmmSearchboxVueApp = createApp({
        data(){
            return {
                currentYear:'0',
                yearList:[{value:'0', label:'Select Year'}],
                currentMake:'0',
                makeList:[{value:'0', label:'Select Make'}],
                currentModel:'0',
                modelList:[{value:'0', label:'Select Model'}],
                currentTrim:'0',
                trimList:[{value:'0', label:'Select Trim'}],             
            }
        },
        computed:{
            isAllowSubmit(){
                return this.currentYear !== '0' && this.currentMake !== '0' && this.currentModel !== '0'
            }
        },
        mounted() {
            
            const routerPathArr = location.pathname.split('/');
            //如果是详情页就不加载
            if(!(routerPathArr.length >= 3 && routerPathArr[routerPathArr.length - 2] === 'products')){
                if(this.getCache('year')&& this.getCache('make')&&this.getCache('model') && this.getCache('trim')){
                    this.autoFillValue();
                }else {
                    // 当前是在collection页面
                    if(/^\/collections/.test(location.pathname)){
                        this.getYearAjaxData({init:false},()=>{
                            this.hideLoading();
                        });
                    }else {
                        this.getYearAjaxData({init:true},()=>{
                            this.hideLoading();
                        });
                    }
                }
                
            }
        },
        methods:{
            // 设置参数
            getParams(params){
                if(params.init){
                    delete params.init;
                    return  Object.assign({},params);
                }else {
                    delete params.init;
                }
                if(/^\/collections/.test(location.pathname)){
                    const collectionCate = [
                        "ledlightsbar",
                        "foglights",
                        "taillight",
                        "catalyticconverter",
                        "controlarms",
                        "headlights",
                        "headlightset",
                        "towingmirrors",
                        "fenderflares",
                        "tonneaucover",
                        "runningboards",
                        "bumper",
                        "floormats",
                        "trailerhitch",
                        "roofrack",
                        "cargomats",
                        "catalyticconvertershield",
                        "runningboard",
                        "crossbars",
                        "sidestep",
                        "headlamps",
                        "taillamps",
                        "taillights",
                        "underseatprotector"
                    ];
                    const collectionName = location.pathname.replace(/^\/collections\//, '').toLowerCase().replace(/-/g, '');
                    const category=collectionCate.findIndex(x=>collectionName.includes(x));
                    if(category!=-1) {
                        const paramsCollection = [
                            "LED Lights Bar",
                            "Fog Lights",
                            "Taillight",
                            "Catalytic Converter",
                            "Control Arms",
                            "Head Lights",
                            "Headlight Set",
                            "Towing Mirrors",
                            "Fender Flares",
                            "Tonneau Cover",
                            "Running Boards",
                            "Bumper",
                            "Floor Mats",
                            "Trailer Hitch",
                            "Roof Rack",
                            "Cargo Mats",
                            "Catalytic Converter Shield",
                            "Running Board",
                            "Cross Bars",
                            "Side step",
                            "Head Lamps",
                            "Tail Lamps",
                            "Tail Lights",
                            "Underseat Protector"
                        ]
                        const myCate = paramsCollection[category];
                        return Object.assign({},{category:myCate},params);
                    }else {
                        return Object.assign({},params);
                    }
                }else {
                    return Object.assign({},params);
                }
            },
            //自动填充值
            autoFillValue(){
                const p0 =  new Promise((resolve, reject) => {
                    if(this.getCache('year')){
                        this.getYearAjaxData({init:true},()=>{
                            this.currentYear = this.getCache('year');
                        });
                    }
                    resolve();
                })

                const p1 = new Promise((resolve, reject) => {
                    if(this.getCache('year') && this.getCache('make')){
                        this.getMakeAjaxData({year: this.getCache('year'),init:true}, () => {
                            this.currentMake = this.getCache('make');
                            resolve();
                        }, true)
                    }else{
                        resolve();
                    }
                })

                const p2 = new Promise((resolve, reject) => {
                    if(this.getCache('make') && this.getCache('model')){
                        this.getModelAjaxData({year: this.getCache('year'), make: this.getCache('make'),init:true}, () => {
                            this.currentModel = this.getCache('model');
                            resolve();
                        }, true)
                    }else{
                        resolve();
                    }
                })

                const p3 = new Promise((resolve, reject) => {
                    if(this.getCache('model') && this.getCache('trim')){
                        this.getTrimAjaxData({year: this.getCache('year'), make: this.getCache('make'), model: this.getCache('model'),init:true}, () => {
                            this.currentTrim = this.getCache('trim');
                            resolve();
                        }, true)
                    }else{
                        resolve();
                    }
                });

       

                this.showSelectLoading(0);
                Promise.all([p0, p1,p2,p3]).then(() => {
                    this.hideSelectLoading(0);
                })
            },
            //重置
            resetForm(){
                this.currentYear = '0';
                this.currentMake = '0';
                this.makeList = [{value:'0', label:'Select Make'}];
                this.currentModel = '0';
                this.modelList = [{value:'0', label:'Select Model'}];
                this.currentTrim = '0';
                this.trimList = [{value:'0', label:'Select Trim'}];
         
                localStorage.removeItem('SelectForShopByVehicleCache');//清除记忆
                // 如果是集合页，需要重新拉year请求
                if(/^\/collections/.test(location.pathname)){
                    this.getYearAjaxData({init:false},()=>{
                        this.hideLoading();
                    });
                }
            },
            //提交
            handlerSubmit(){
                var url = '';
                var joinStr = '~'; //每个下拉框之间的连接符
                var selectJoinStr = '-'; //下拉框内参数连接符
                if(this.currentYear !== '0'){
                    this.setCache({year: this.currentYear})
                    url += 'yr_' + this.currentYear
                }else{
                    this.setCache({year: '0'})
                }

                if(this.currentMake !== '0'){
                    this.setCache({make: this.currentMake})
                    url += joinStr + 'mk_' + this.currentMake.replace(/\s|\./g, selectJoinStr)
                }else{
                    this.setCache({make: '0'})
                }

                if(this.currentModel !== '0'){
                    this.setCache({model: this.currentModel})
                    url += joinStr + 'md_' + this.currentModel.replace(/\s|\./g, selectJoinStr)
                }else{
                    this.setCache({model: '0'})
                }

                if(this.currentTrim !== '0'){
                    this.setCache({trim: this.currentTrim})
                    url += joinStr + 'kj_' + this.currentTrim.replace(/\s|\./g, selectJoinStr)
                }else{
                    this.setCache({trim: '0'})
                }

               // 共有两个地方使用一样的代码
                var carLoadingEle = document.createElement('div');
                carLoadingEle.innerHTML = `
                  <div class="car-loading">
                    <img src="https://www.yitamotor.com/cdn/shop/t/70/assets/car-loading.gif" class="car-loading-img" alt="">
                  </div>
                `
                document.body.append(carLoadingEle)

                location.href = '/pages/product-result?rq=' + url.toLowerCase();
            },
            getCache(key){
                var selectionCacheStr = localStorage.getItem('SelectForShopByVehicleCache');
                var selectionCache = {};
                if(/^{.*}$/.test(selectionCacheStr)){
                    selectionCache = JSON.parse(selectionCacheStr);
                }
                return selectionCache[key] && selectionCache[key] != '0'? selectionCache[key]: ''
            },

            setCache(options){
                var selectionCacheStr = localStorage.getItem('SelectForShopByVehicleCache');
                var selectionCache = {};
                if(/^{.*}$/.test(selectionCacheStr)){
                    selectionCache = JSON.parse(selectionCacheStr);
                }
                if(options.year){
                    selectionCache.year = options.year;
                }
                if(options.make){
                    selectionCache.make = options.make;
                }
                if(options.model){
                    selectionCache.model = options.model;
                }
                if(options.trim){
                    selectionCache.trim = options.trim;
                }
                localStorage.setItem('SelectForShopByVehicleCache', JSON.stringify(selectionCache));
            },
            changeYear(){
                this.currentMake = '0';
                this.makeList = [{value:'0', label:'Select Make'}];
                this.currentModel = '0';
                this.modelList = [{value:'0', label:'Select Model'}];
                this.currentTrim = '0';
                this.trimList = [{value:'0', label:'Select Trim'}];
        
                this.getMakeAjaxData({year: this.currentYear})
            },
            changeMake(){
                this.currentModel = '0';
                this.modelList = [{value:'0', label:'Select Model'}];
                this.currentTrim = '0';
                this.trimList = [{value:'0', label:'Select Trim'}];
               
                this.getModelAjaxData({year: this.currentYear, make: this.currentMake})
            },
            changeModel(){
                this.currentTrim = '0';
                this.trimList = [{value:'0', label:'Select Trim'}];
           
                this.getTrimAjaxData({year: this.currentYear, make: this.currentMake, model: this.currentModel})
            },
            changeTrim(){
            
            },
          

            getYearAjaxData(opts,callback, isNotShowLoading){
                var t = this;
                !isNotShowLoading && t.showSelectLoading(0);
                const params = this.getParams({
                    key:'year',
                    init:opts.init
                });
                myAjax({
                    url:'api/shopify/vehicle/options',
                    data: params
                }).then(data => {
                    console.log('year-data:', data)
                    if(Array.isArray(data.data)){
                        t.yearList = [{value:'0', label:'Select Year'}, ...data.data.map(item => ({value: item, label: item}))]
                    }
                    !isNotShowLoading && t.hideSelectLoading(0)
                    typeof callback === 'function' && callback()
                })

            },

            getMakeAjaxData(opts, callback, isNotShowLoading){
                var t = this;
                !isNotShowLoading && t.showSelectLoading(1); 
                 const params = this.getParams({
                    key:'make',
                    year: opts.year,
                    init:opts.init
                });
                myAjax({
                    url: 'api/shopify/vehicle/options',
                    data: params
                }).then(data => {
                    console.log('make-data:', data)
                    if(Array.isArray(data.data)){
                        let allCars=["Chevrolet","GMC","Ford","Dodge","Ram","Toyota","Nissan","Jeep","Honda","Cadillac","Pontiac","Chrysler","Buick","Lincoln","BMW","Hyundai","Isuzu","Mazda","Infiniti","Tesla","Kia","Lexus","Subaru","Mercedes-Benz","Oldsmobile","Saturn","Acura","SAAB","Suzuki","Mercury","Volkswagen","Freightliner","Mitsubishi","Plymouth","Peterbilt","Savana","Scion","Sienna","Hummer","Volvo","Kenworth"];
                        let res = data.data;
                        let finArr=[];
                        let first = allCars.filter(x=>res.indexOf(x)!=-1);
                        finArr=[].concat(first);
                        if(first.length<res.length){
                            finArr=finArr.concat(res.filter(x=>first.indexOf(x)===-1));
                        }
                        t.makeList = [{value:'0', label:'Select Make'}, ...finArr.map(item => ({value: item, label: item}))]
                    }
                    !isNotShowLoading && t.hideSelectLoading(1)
                    typeof callback === 'function' && callback()
                })
            },

            getModelAjaxData(opts, callback, isNotShowLoading){
                var t = this;
                !isNotShowLoading && t.showSelectLoading(2);
                const params = this.getParams({
                    key: 'model',
                    year: opts.year,
                    make: opts.make,
                    init:opts.init
                });
                myAjax({
                    url: 'api/shopify/vehicle/options',
                    data: params
                }).then(data => {
                    console.log('model-data:', data)
                    if (Array.isArray(data.data)) {
                        t.modelList = [{value: '0', label: 'Select Model'}, ...data.data.map(item => ({
                            value: item,
                            label: item
                        }))]
                    }
                    !isNotShowLoading && t.hideSelectLoading(2)
                    typeof callback === 'function' && callback()
                })
            },

            getTrimAjaxData(opts,callback, isNotShowLoading){
                var t = this;
                !isNotShowLoading && t.showSelectLoading(3);
                const params = this.getParams({
                    key: 'trim',
                    year: opts.year,
                    make: opts.make,
                    model: opts.model,
                    init:opts.init
                });
                myAjax({
                    url: 'api/shopify/vehicle/options',
                    data: params
                }).then(data => {
                    console.log('trim-data:', data)
                    if (Array.isArray(data.data)) {
                        t.trimList = [{value: '0', label: 'Select Trim'}, ...data.data.map(item => ({
                            value: item,
                            label: item
                        }))]
                    }
                    !isNotShowLoading && t.hideSelectLoading(3)
                    typeof callback === 'function' && callback()
                })
            },
            showLoading(){
                if(document.querySelector('.component-full-loading')){
                    return;
                }
                var ele = document.createElement('div');
                ele.className = 'component-full-loading';
                ele.innerHTML = `
            <div class="loading-wrapper" style="position: fixed;top: 0;left: 0;width: 100%;height: 100%;background: #0000004f;z-index:999999999;">
                 <div class="inner-loading" style="background: #494949;border: 1px solid #ccc; color: #fff; text-align: center; position: absolute;left:50%; top:50%; transform: translate(-50%, -50%);line-height: 38px;width: 150px;border-radius: 5px;">
                    <img style="vertical-align: middle;margin-right: 10px;" src="data:image/gif;base64,R0lGODlhEAAQALMMAKqooJGOhp2bk7e1rZ2bkre1rJCPhqqon8PBudDOxXd1bISCef///wAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFAAAMACwAAAAAEAAQAAAET5DJyYyhmAZ7sxQEs1nMsmACGJKmSaVEOLXnK1PuBADepCiMg/DQ+/2GRI8RKOxJfpTCIJNIYArS6aRajWYZCASDa41Ow+Fx2YMWOyfpTAQAIfkEBQAADAAsAAAAABAAEAAABE6QyckEoZgKe7MEQMUxhoEd6FFdQWlOqTq15SlT9VQM3rQsjMKO5/n9hANixgjc9SQ/CgKRUSgw0ynFapVmGYkEg3v1gsPibg8tfk7CnggAIfkEBQAADAAsAAAAABAAEAAABE2QycnOoZjaA/IsRWV1goCBoMiUJTW8A0XMBPZmM4Ug3hQEjN2uZygahDyP0RBMEpmTRCKzWGCkUkq1SsFOFQrG1tr9gsPc3jnco4A9EQAh+QQFAAAMACwAAAAAEAAQAAAETpDJyUqhmFqbJ0LMIA7McWDfF5LmAVApOLUvLFMmlSTdJAiM3a73+wl5HYKSEET2lBSFIhMIYKRSimFriGIZiwWD2/WCw+Jt7xxeU9qZCAAh+QQFAAAMACwAAAAAEAAQAAAETZDJyRCimFqbZ0rVxgwF9n3hSJbeSQ2rCWIkpSjddBzMfee7nQ/XCfJ+OQYAQFksMgQBxumkEKLSCfVpMDCugqyW2w18xZmuwZycdDsRACH5BAUAAAwALAAAAAAQABAAAARNkMnJUqKYWpunUtXGIAj2feFIlt5JrWybkdSydNNQMLaND7pC79YBFnY+HENHMRgyhwPGaQhQotGm00oQMLBSLYPQ9QIASrLAq5x0OxEAIfkEBQAADAAsAAAAABAAEAAABE2QycmUopham+da1cYkCfZ94UiW3kmtbJuRlGF0E4Iwto3rut6tA9wFAjiJjkIgZAYDTLNJgUIpgqyAcTgwCuACJssAdL3gpLmbpLAzEQA7" alt="loading">
                    <span style="vertical-align: middle;">loading...</span>
                </div>
            </div>
        `
                document.body.appendChild(ele);
            },

            hideLoading (){
                var ele = document.querySelector('.component-full-loading')
                ele && document.body.removeChild(ele);
            },

          showSelectLoading(nth){
                var ymm = document.querySelector('#ymm_hid');
                var li = ymm?.querySelectorAll('li')[nth];
                if(li){
                    li.classList.add('is-loading-select')
                }
            },
            hideSelectLoading(nth){
                var ymm = document.querySelector('#ymm_hid');
                var li = ymm?.querySelectorAll('li')[nth];
                if(li){
                    li.classList.remove('is-loading-select')
                }
            }

        }
    }).mount('#ymm_hid')

}
